/* eslint-disable */
import { library } from '@fortawesome/fontawesome-svg-core';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fat } from '@fortawesome/pro-thin-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';

library.add(fad);
// @ts-ignore
library.add(fas);
// @ts-ignore
library.add(far);
// @ts-ignore
library.add(fat);
// @ts-ignore
library.add(fal);

const ICONS = [];

export function configureIcons(...icons) {
  [...new Set([...ICONS, ...icons.flat()])]
    .filter((icon) => (typeof icon !== 'string'))
    .forEach((icon) => {
      library.add(icon);
    });
}

export default configureIcons;
